import React from "react";
import FilterProto from "../lib/filter-field-proto";
// @ts-ignore
import MultiselectFilter from "../../../gd-app/panels/filters-panel/filter-form/multiselect/multiselect";
import FieldProto from "../../../fields3/proto/field-proto";

const debug = "FilterField3_DropdownDynamic"
// const debug = false

export default class FilterField3_DropdownDynamic extends FilterProto {

    constructor(filtersManager:any, field:FieldProto, initValue:any) {

        // this.filterConfig is field2 object
        // field eto deistvitel'no field here... no on used as filter Config
        super(filtersManager, field, initValue, field.label);

        this.optionsSet = new Set();
        this.optionsSet.add(null);

        //Tut nado posovetovatsya s Vic.

        // _.map(this.filterConfig.getOptions(),(option)=>{ // patch by vic ... used in filter glist for expenes... tam ne fixes options to...
        // // _.map(this.filterConfig.options,(option)=>{
        //     this.optionsSet.add(option.value);
        // });

        this.field          = this.filterConfig.fieldId;
        this.isCustomField  = this.filterConfig.isCustom;
    }

    optionsFillerFunc(model:any) {
        const value : any = _.get(model, this.filterConfig.fieldId) // skoree vsego ID ?
        if (value) {
            this.optionsSet.add(value)
        }
    }


    getFilterOptions() {

        debug && console.log(debug, "getFilterOptions() optionsSet=", this.optionsSet)

        // const options : Option[] = [{
        //     value   : null,
        //     label   : 'Not set',
        // }];

        const field         : FieldProto = this.filterConfig as FieldProto
        const options       : Option[] = field.getFilterOptions(this.optionsSet)

        return options;
    }

    getValue() {
        return this.value ? this.value : [...this.optionsSet];
    }

    setValue(val:any, silent:boolean=false) {
        // reset value to null if all options selected
        if (!val || [...this.optionsSet].length === val.length) {
            val = null;
            this.isEnabled = false;
        } else {
            this.isEnabled = true;
        }

        super.setValue(val, silent);
    }

    filterFuncUniversal(model:any) {
        if (!this.value) return true; //null;

        const fieldValue = model[this.filterConfig.fieldId]
        if (!fieldValue) {
            return this.value.includes(null);
        }

        return this.value.includes(fieldValue);
    }


    render() {
        return <MultiselectFilter filter={this} />
    }
}
